import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'initials',
})
export class InitialsPipe implements PipeTransform {
	transform(value: string): string {
		const initials = value
			.split(' ')
			.map((word) => word.charAt(0).toUpperCase())
			.join('');
		return initials;
	}
}
